import { applyMiddleware, compose, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunkMiddleware from 'redux-thunk';
import { APP_AUTH_KEY } from '../constants/env';
import allReducers from './reducers';
const persistConfig = {
    key: APP_AUTH_KEY,
    storage: storage,
    writeFailHandler: function (err) {
        console.log("ERR in writeFailHandler::::", err);
    },
    //Auth
    whitelist: [
        'auth',
        'plans',
        'gifting'
    ],
}

const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    trace: true,
}) : compose;

const persistedReducer = persistReducer(persistConfig, allReducers);

export const store = createStore(persistedReducer, composeEnhancers(applyMiddleware(thunkMiddleware)));

export const persistor = persistStore(store);
